import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { LOADING_UI, UNLOADING_UI } from "../redux/types";
import { InitialStateUserType } from "../typings/state";

const Home = () => {
  const dispatch = useDispatch();
  const user = useSelector(
    (state: { user: InitialStateUserType }) => state.user
  );
  let history = useHistory();
  useEffect(() => {
    dispatch({ type: LOADING_UI });
  }, []);
  useEffect(() => {
    dispatch({ type: UNLOADING_UI });
    if (user.authenticated) {
      history.push("/dashboard");
    }else{
      history.push("/auth/login");
    }
  }, [user]);
  return (
    <></>
  )
}

export default Home;
